import { z } from 'zod';
import { emailSchema } from './auth';

/** A super user invites someone; the link works once, before it expires. */
export const createInviteSchema = z.object({
  /** Locks the invitation to this address (and emails it there, when mail is set up). */
  email: emailSchema.nullable().default(null),
  note: z.string().trim().max(120).nullable().default(null),
});
export type CreateInvite = z.infer<typeof createInviteSchema>;

export const inviteStatusSchema = z.enum(['pending', 'accepted', 'expired', 'revoked']);
export type InviteStatus = z.infer<typeof inviteStatusSchema>;

export const inviteSchema = z.object({
  id: z.number().int(),
  email: z.string().nullable(),
  note: z.string().nullable(),
  status: inviteStatusSchema,
  createdAt: z.string(),
  expiresAt: z.string(),
  /** Who signed up with it. */
  acceptedBy: z.string().nullable(),
});
export type Invite = z.infer<typeof inviteSchema>;

export const createdInviteSchema = z.object({
  invite: inviteSchema,
  /** The link to share. Shown once: only a hash of it is kept. */
  url: z.string(),
  emailed: z.boolean(),
});
export type CreatedInvite = z.infer<typeof createdInviteSchema>;

/** What the sign-up page learns about an invitation before it is used. */
export const invitePreviewSchema = z.object({
  email: z.string().nullable(),
  expiresAt: z.string(),
});
export type InvitePreview = z.infer<typeof invitePreviewSchema>;

export const inviteTokenParamsSchema = z.object({ token: z.string().min(20).max(200) });
